/**
 * CHARGER UNE RESSOURCE. Un état, trois cas : en cours, erreur, données.
 *
 * Pas de bibliothèque de cache : les écrans de Destinia relisent le serveur à chaque geste (une
 * action de partie RENVOIE la partie entière — c'est la discipline des routes), et un cache qui
 * garderait la version d'avant serait un cache qui ment sur les PV.
 */
import { useCallback, useEffect, useState } from "react";

import { api } from "./client.js";

export interface Chargement<T> {
  donnees: T | null;
  erreur: unknown;
  enCours: boolean;
  recharge: () => void;
}

export function useRessource<T>(chemin: string | null, extrait: (charge: never) => T): Chargement<T> {
  const [donnees, poseLesDonnees] = useState<T | null>(null);
  const [erreur, poseLErreur] = useState<unknown>(null);
  const [enCours, poseEnCours] = useState<boolean>(chemin !== null);
  const [tour, poseLeTour] = useState(0);

  const recharge = useCallback(() => poseLeTour((t) => t + 1), []);

  useEffect(() => {
    if (chemin === null) {
      poseEnCours(false);
      return;
    }
    let vivant = true;
    poseEnCours(true);
    poseLErreur(null);
    api
      .lis<never>(chemin)
      .then((charge) => {
        if (!vivant) return;
        poseLesDonnees(extrait(charge));
        poseEnCours(false);
      })
      .catch((e: unknown) => {
        if (!vivant) return;
        poseLErreur(e);
        poseEnCours(false);
      });
    // L'écran qu'on quitte ne doit pas écrire dans celui qui arrive : un joueur qui enchaîne deux
    // nœuds vite verrait le premier écraser le second.
    return () => {
      vivant = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chemin, tour]);

  return { donnees, erreur, enCours, recharge };
}
